import '|/app.styl';
import '|/bootstrap.scss';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    // Refresh our requests values
    $.ajax({
        type:     'post',
        dataType: 'json',
        url:      admin.ajaxUrl,
        data:     {
            action:   'll4_t2d_refresh_cache',
            nonce:    admin.cacheNonce,
            no_cache: true
        },
        error:    function (xhr, status, error) {
            /*console.log('Error');
            console.log(xhr, status, error);*/
        },
        success:  function (data, status, xhr) {
            /*console.log('Success');
            console.log(data, status, xhr);*/
        }

    });

    // Routiunes to run after page loads
    $(document).ready(function () {

        // Clear Things to Do filters
        $('[data-filter-clear]').on('click', function (e) {

            // Declare and initialize
            let target   = $(this).data('filter-clear');
            let form     = $(this).closest('form');
            let clearAll = '_all' === $(this).data('filter-clear');

            // If we want to clear all inputs, do so
            if (clearAll) {

                // Find all the inputs
                let inputs = form.find('input:not([type="submit"]), select');

                // Run through them
                inputs.each(function (i) {

                    // Clear out the value based on input type
                    if ($(this).is('select'))
                        $(this).prop('selectedIndex', 0);
                    else
                        $(this).val('');

                });

                // Hide the individual clear togglers
                form.find('[data-filter-clear]').not($(this)).hide();

            } else {

                // If there is no target, bail out
                if (!target)
                    return;

                // Find the target
                let input = form.find('[name="' + target + '"]');

                // If there is no input, bail out
                if (!input.length)
                    return;

                // Clear out the value based on input type
                if (input.is('select'))
                    input.prop('selectedIndex', 0);
                else
                    input.val('');

                // Hide the toggler
                $(this).hide();

            }

        });

        // Toggle the filter clear button
        $('[data-has-clear]').on('input', function (e) {

            // Declare and initialize
            let container = $(this).closest('[data-has-clear-container]');
            let value     = $(this).val();
            let clearer   = container.find('[data-filter-clear]');

            // If there is no clear button, bail out
            if (!clearer.length)
                return;

            // Toggle the clear button based on value
            if (!!value)
                clearer.show();
            else
                clearer.hide();
        });

    });

})(jQuery);